/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { motion } from "framer-motion";
import { FaCheck } from "react-icons/fa";

export default function ThemesSection({
  themes = [],
  selectedThemeId,
  selectedVariant,
  handleThemeClick,
  handleVariantClick,
  isArabic,
  COLORS,
  isMobile,
}) {
  if (!Array.isArray(themes)) return null;

  return (
    <div style={{ marginBottom: "30px" }}>
      <h5
        className="fw-bold mb-4 text-center"
        style={{
          color: COLORS.gold,
          fontSize: isMobile ? "1.1rem" : "1.3rem",
          fontFamily: "'Cairo', sans-serif",
        }}
      >
        {isArabic ? "اختر الثيم" : "Select Theme"}
      </h5>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
          gap: "20px",
          maxWidth: "800px",
          margin: "0 auto",
        }}
      >
        {themes.map((themeItem, index) => {
          const isSelected = themeItem.id === selectedThemeId;
          const activeVariant =
            isSelected
              ? selectedVariant || themeItem.variants[0]
              : themeItem.variants[0];

          return (
            <motion.div
              key={themeItem.id}
              whileHover={{ y: -8, scale: 1.02 }}
              onClick={() => handleThemeClick(themeItem)}
              style={{
                position: "relative",
                background: isSelected
                  ? "rgba(255,255,255,0.12)"
                  : "rgba(255,255,255,0.05)",
                borderRadius: "16px",
                padding: "16px",
                border: isSelected
                  ? `2px solid ${COLORS.gold}`
                  : "1px solid rgba(255,255,255,0.15)",
                cursor: "pointer",
              }}
            >
              {/* الحاوية مع تأثير التمرير */}
              <div 
                className="group"
                style={{
                  width: "100%",
                  height: "150px",
                  overflow: "hidden",
                  borderRadius: "12px",
                  marginBottom: "12px",
                  position: "relative",
                  background: "#fff"
                }}
              >
                <img
                  src={activeVariant.img}
                  alt={themeItem.name}
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    transition: "transform 4s ease-in-out",
                    transform: "translateY(0)"
                  }}
                  onMouseEnter={(e) => {
                    const imgHeight = e.currentTarget.offsetHeight;
                    const containerHeight = 150; 
                    if (imgHeight > containerHeight) {
                      e.currentTarget.style.transform = `translateY(-${imgHeight - containerHeight}px)`;
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                />
              </div>

              <h3
                style={{
                  textAlign: "center",
                  marginBottom: "10px",
                  fontWeight: "700",
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  color: COLORS.textLight,
                }}
              >
                {themeItem.name}
              </h3>

              <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
                {themeItem.variants.map((v) => (
                  <div
                    key={v.name}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleVariantClick(themeItem.id, v);
                    }}
                    style={{
                      width: 26,
                      height: 26,
                      borderRadius: "50%",
                      background: v.colors.primary,
                      outline:
                        isSelected && selectedVariant?.name === v.name
                          ? "3px solid #22C55E"
                          : "none",
                      cursor: "pointer",
                    }}
                  />
                ))}
              </div>

              {isSelected && (
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    background: "#22C55E",
                    color: "#fff",
                    padding: 6,
                    borderRadius: "50%",
                  }}
                >
                  <FaCheck size={12} />
                </div>
              )}
            </motion.div>
          );
        })}
      </div>

      {/* --- بداية إضافة النص الإرشادي (Tip) --- */}
      <div
        style={{
          marginTop: "25px",
          textAlign: "center",
          padding: "15px",
          borderRadius: "12px",
          background: "rgba(255, 255, 255, 0.05)",
          maxWidth: "600px",
          margin: "25px auto 0",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <p
          style={{
            fontSize: isMobile ? "0.8rem" : "0.9rem",
            color: "rgba(255, 255, 255, 0.6)",
            margin: 0,
            lineHeight: "1.6",
          }}
        >
          {isArabic ? (
            <>💡 نصيحة: مرر الماوس فوق الثيم لمعاينته. انقر لتحديده واحفظ التغييرات.</>
          ) : (
            <>💡 Tip: Hover over a theme to preview it. Click to select and save your changes.</>
          )}
        </p>
      </div>
      {/* --- نهاية التعديل --- */}
    </div>
  );
}